"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
exports.EMPTY_SELECTIONRANGE = { start: null, end: null };
//# sourceMappingURL=SelectionRange.js.map